// ACHTUNG!! Muss JSON sein, keine Komentare!
export default {
  "entrypoints": {
    "navigation": {"php": false},
    "cookie-notice": {"php": false},
    "swiper": {"php": false},
    "accordion": {"php": false},
    "lightgallery": {"php": false},
    "immo-expose": {"php": false},
    "immoapp-exposecontact": {"php": false},
    "immoapp-savedsearch": {"php": false},
    "immoapp-search": {"php": false},
    "immoapp-finder": {"php": false},
    "contact": {"php": false},
    "tabs": {"php": false},
    "modal": {"php": false},
    "immo-listing": {"php": false},
    "testimonial-app": {"php": false},
    "testimonial-archive": {"php": false},
    "iframe-resizer": {"php": false},
    "newsletter": {"php": false}
  }
}
